function goProgressBar() {
    var bar = document.getElementById("maf_Progress_Bar");
    if (bar.parentElement && bar.parentElement.parentElement) {
        var barWrapper = bar.parentElement.parentElement;
        barWrapper.style.display = 'block';
    }
    var width = 20;
    var id = setInterval(moving, 10);
    function moving() {
        if (width >= 100) {
            return clearInterval(id);
        }
        width++;
        bar.style.width = width + '%';
    }
    return false;
}

function insertProgressBar(button) {
    var beforeButtons = $(button).closest('.maf-modal-ctas');
    if ($('.modal-body-membership')[1] && $('.modal-body-membership')[1].childNodes) {
        var membershipBodyChildren = $('.modal-body-membership')[1].childNodes.length;
    }
    if (beforeButtons && (membershipBodyChildren < 6)) {
        $(beforeButtons).before(
            '<div class="spinner-grow" role="status">' +
            '<span class="sr-only">Adding to Cart</span>' +
            '</div>' +
            '<div class="maf-component maf-component-progress-bar-wrap">' +
            'Adding to Cart' +
            '<div class="maf-component maf-component-progress-bar">' +
            '<div id="maf_Progress_Bar" style="width:20%"></div>' +
            '</div>' +
            '</div>'
        );
        goProgressBar(button);
    }
}

function selectPlan(progressBar, planId, button) {
    $("#membershipPlans option[data-value-id='" + planId + "']").prop("selected", true);
    $('button.add-to-cart').trigger('click');
    if (progressBar) {
        insertProgressBar(button);
    }
    // ----------------------
    //    REDIRECT TO CART
    // ----------------------
    setTimeout(function() {
        $('html, body').animate({
            scrollTop: $('.minicart-link').offset().top - 200
        });
        var cartURL = $('.minicart-link, .minicart-icon').attr("href");
        location.href = cartURL;
    }, 1500);
}

function selectPlanLogin(progressBar, planId, button) {
    // var buttonID = $(button)[0].id;
    //console.log(buttonID);
    $("#membershipPlans option[data-value-id='" + planId + "']").prop("selected", true);
    $('button.add-to-cart').trigger('click');
    if (progressBar) {
        insertProgressBar(button);
    }
    // ----------------------
    //    REDIRECT TO AUTH0
    // ----------------------
    setTimeout(function() {
        $('html, body').animate({
            scrollTop: $('.minicart-link').offset().top - 200
        });
        window.location.href = "/on/demandware.store/Sites-medicalert-Site/default/Login-OAuthLogin?oauthProvider=auth0&oauthLoginTargetEndPoint=3";
    }, 1500);
}

(function() {

    // -------------------
    //  SELECTING A PLAN
    // -------------------

    // NO PLAN BASIC SELECTION
    $('#btnNoPlan_s').one('click', function(e) {
        selectPlan(true, '80161', this);
    });

    // ALREADY HAVE A PLAN BASIC SELECTION
    $('#maf_Plan_addToCart_Panel1, #maf_SmartMedicalID_addToCart_noPlan, #maf_renewalPlan_addToCart').one('click', function(e) {
        selectPlan(false, '00000', this);
    });

    // ALREADY HAVE FROM PDP
    $('#btnAlreadyHavePlan').one('click', function(e) {
        selectPlanLogin(true, '00000', this);
    });

    // PLAN BASIC SELECTION
    // $('#btnBasic_1year, #btnBasic_1year_mob').one('click', function(e) {
    //     $("#membershipModalPDP").modal("toggle");
    //     selectPlan(false, '80155', this);
    // });

    // PLAN ADVANTAGE SELECTION
    // $('#btnAdvantage_1year, #btnAdvantage_1year_mob').one('click', function(e) {
    //     $("#membershipModalPDP").modal("toggle");
    //     selectPlan(false, '80106', this);
    // });

    // PLAN ADVANTAGE PLUS SELECTION
    // $('#btnAdvantagePlus_1year, #btnAdvantagePlus_1year_mob').one('click', function(e) {
    //     $("#membershipModalPDP").modal("toggle");
    //     selectPlan(false, '80149', this);
    // });

    // SAFE PLAN $35
    $('#btnSafe_1year, #btnBasic_1year_mob').one('click', function(e) {
        $("#membershipModalPDP").modal("toggle");
        selectPlan(false, '80177', this);
    });

    // PLAN SAFE & CONNECTED SELECTION
    $('#btnSafeConnected_1year').one('click', function(e) {
        $("#membershipModalPDP").modal("toggle");
        selectPlan(false, '80180', this);
    });

    // PLAN SAFE & FOUND SELECTION
    $('#btnSafeFound_1year, #btnSafeFound_1year_mob').one('click', function(e) {
        $("#membershipModalPDP").modal("toggle");
        selectPlan(false, '80183', this);
    });

    // --------------------
    //  TOGGLE MODAL PLANS
    // --------------------

    // $('#btnOffer_3Years_Basic, #btnOffer_3Years_Basic_Mob').click(function(e) {
    //     $("#membershipModalPDP").modal("toggle");
    //     $("#3yearPlanBasicModalPDP").modal("toggle");
    //     history.pushState({ id: "BasicPlan" }, "Selected: BasicPlan", "#selected=Basic_Plan_Panel");

    // });
    // $('#btnOffer_3Years_Advantage, #btnOffer_3Years_Advantage_Mob').click(function(e) {
    //     $("#membershipModalPDP").modal("toggle");
    //     $("#3yearPlanAdvantageModalPDP").modal("toggle");
    //     history.pushState({ id: "AdvantagePlan" }, "Selected: AdvantagePlan", "#selected=Advantage_Plan_Panel");
    // });
    // $('#btnOffer_3Years_AdvantagePlus, #btnOffer_3Years_AdvantagePlus_Mob').click(function(e) {
    //     $("#membershipModalPDP").modal("toggle");
    //     $("#3yearPlanAdvantagePlusModalPDP").modal("toggle");
    //     history.pushState({ id: "AdvantagePlusPlan" }, "Selected: AdvantagePlusPlan", "#selected=Advantage_Plus_Panel");
    // });
    $('#YesSelectaPlan').click(function(e) {        
        $("#noPlanConfirmationModalPDP").modal("toggle");
        $("#membershipModalPDP").modal("toggle");            
        $('#membershipModalPDP').on('shown.bs.modal', function() {
            if($(".flickity-viewport").is(":visible")){
                $("#membershipModalPDP").animate({ scrollTop: 400 });
            }
        });
    });
    $('#btnConfirmNoPlan').click(function(e) {
        $("#membershipModalPDP").modal("toggle");
        $("#noPlanConfirmationModalPDP").modal("toggle");
    });

})();
